// extracted by mini-css-extract-plugin
export var imageW100 = "cover-module--imageW100--fc22d";
export var partnerButton = "cover-module--partnerButton--66edc";
export var partnerLink = "cover-module--partnerLink--51042";
export var sectionContent = "cover-module--sectionContent--bb04c";
export var socialButton = "cover-module--socialButton--7d293";
export var tag = "cover-module--tag--73488";
export var v2Category = "cover-module--v2Category--cfee2";
export var v2Container = "cover-module--v2Container--17026";
export var v2DetailsContainer = "cover-module--v2DetailsContainer--5b1c4";
export var v2Image = "cover-module--v2Image--5e752";
export var v2ImageContainer = "cover-module--v2ImageContainer--b5c69";
export var v2ImageDescription = "cover-module--v2ImageDescription--c4d07";
export var v2PartnersContainer = "cover-module--v2PartnersContainer--4d841";
export var v2PartnersTitle = "cover-module--v2PartnersTitle--ad4e6";
export var v2PostedContainer = "cover-module--v2PostedContainer--16af3";
export var v2PostedDate = "cover-module--v2PostedDate--aa8a7";
export var v2PostedTitle = "cover-module--v2PostedTitle--c0032";
export var v2ShareContainer = "cover-module--v2ShareContainer--c5ec1";
export var v2ShareContent = "cover-module--v2ShareContent--e30e1";
export var v2ShareTitle = "cover-module--v2ShareTitle--2c4df";
export var v2Tags = "cover-module--v2Tags--2af35";
export var v2TagsContainer = "cover-module--v2TagsContainer--9118f";
export var v2TagsTitle = "cover-module--v2TagsTitle--e2c24";
export var v2ThumbnailContainer = "cover-module--v2ThumbnailContainer--e4100";
export var v2ThumbnailTextContainer = "cover-module--v2ThumbnailTextContainer--c5e7c";
export var v2Title = "cover-module--v2Title--dc2bc";
export var v2TitleContainer = "cover-module--v2TitleContainer--8b799";